import { render, staticRenderFns } from "./myCollection.vue?vue&type=template&id=0d6a7d8c&scoped=true"
import script from "./myCollection.vue?vue&type=script&lang=js"
export * from "./myCollection.vue?vue&type=script&lang=js"
import style0 from "./myCollection.vue?vue&type=style&index=0&id=0d6a7d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a7d8c",
  null
  
)

export default component.exports